import { render, staticRenderFns } from "./customerKyc.vue?vue&type=template&id=791d6ccc&scoped=true"
import script from "./customerKyc.vue?vue&type=script&lang=js"
export * from "./customerKyc.vue?vue&type=script&lang=js"
import style0 from "./customerKyc.vue?vue&type=style&index=0&id=791d6ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791d6ccc",
  null
  
)

export default component.exports